import {
  CommunicationOption,
  ContentProps,
} from 'models/profile-settings.model';
import { toBoolean } from 'utils/to-boolean';

type EmailOptionId = 'STR_PERSONALIZED_EMAIL' | 'STR_TIPS_AND_RECOMMENDATIONS';
type ExcludedOptionId = 'STR_PAPERLESS' | EmailOptionId;

const EMAIL_OPTION_IDS: readonly EmailOptionId[] = [
  'STR_PERSONALIZED_EMAIL',
  'STR_TIPS_AND_RECOMMENDATIONS',
];

const EXCLUDED_OPTION_IDS: readonly ExcludedOptionId[] = [
  'STR_PAPERLESS',
  ...EMAIL_OPTION_IDS,
];

const LABEL_VALUE_MAP: Record<
  string,
  { trueValue: string; falseValue: string }
> = {
  STR_LANGUAGE: { trueValue: 'STR_SPANISH', falseValue: 'STR_ENGLISH' },
};

export const formatCommunicationOptions = (
  options: CommunicationOption[],
  formatMessage: any,
): ContentProps[] => {
  const contents: ContentProps[] = [];

  const formatBooleanValue = (
    labelId: string,
    value: string | boolean,
  ): string => {
    const { trueValue = 'STR_YES', falseValue = 'STR_NO' } =
      LABEL_VALUE_MAP[labelId] ?? {};
    return formatMessage({ id: toBoolean(value) ? trueValue : falseValue });
  };

  const paperlessOption = options.find(
    (opt) => opt.labelId === 'STR_PAPERLESS',
  );
  if (paperlessOption) {
    contents.push({
      labelId: 'STR_PAPERLESS',
      value: formatBooleanValue('STR_PAPERLESS', paperlessOption.value),
    });
  }

  const emailOptions = options.filter(
    (opt): opt is CommunicationOption & { labelId: EmailOptionId } =>
      EMAIL_OPTION_IDS.includes(opt.labelId as EmailOptionId),
  );
  const emailValues = emailOptions
    .filter((opt) => toBoolean(opt.value))
    .map((opt) =>
      formatMessage({
        id:
          opt.labelId === 'STR_PERSONALIZED_EMAIL'
            ? 'STR_EMAIL_PERSONALIZED_UPDATES'
            : opt.labelId,
      }),
    )
    .map((value) => `<div>${value}</div>`)
    .join('');

  contents.push({
    labelId: 'STR_EMAIL_TITLE',
    value: emailValues || `<div>${formatMessage({ id: 'STR_NO' })}</div>`,
  });

  options
    .filter(
      (opt) => !EXCLUDED_OPTION_IDS.includes(opt.labelId as ExcludedOptionId),
    )
    .forEach((opt) => {
      contents.push({
        labelId: opt.labelId,
        value: formatBooleanValue(opt.labelId, opt.value),
      });
    });

  return contents;
};
